// Exports
export default {
	"conference": "conference_dTT44",
	"oneColLayout": "oneColLayout_UoLfC",
	"selected": "selected_uK3ZQ",
	"beginEnd": "beginEnd_C3bd-",
	"nameAndTags": "nameAndTags_Ldvub",
	"tags": "tags_bCCJj"
};
